import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de recherche pour la documentation
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-recherche-documentation',
  templateUrl: './recherche-documentation.component.html',
  styleUrls: ['./recherche-documentation.component.scss']
})
export class RechercheDocumentationComponent extends BaseComponent implements OnInit {
    recherche: string = '';
    rechercherDansToutesLesLangues: boolean = false;

    @Output() readonly rechercheEvent: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.rechercher();
    }

    /**
     * Lancer la recherche
     */
    rechercher(): void {
        // Lancer la recherche
        this.rechercheEvent.emit({ Recherche: this.recherche, RechercherDansToutesLesLangues: this.rechercherDansToutesLesLangues });
    }
}
